import Splide from "@splidejs/splide";
Drupal.behaviors.slider = {
  attach: function (context) {
    const sliders = document.querySelectorAll( ".slider.splide" );
    var currentSlideIndicators = document.querySelectorAll('.js-current-slide');
    
    /* Options for slider */
    let sliderOptions  = {
      type      : "loop",
      perPage   : 1,
      speed     : 1000,
      arrows    : true,
      pagination: false,
    }
   sliders.forEach((slider) => {
      const splide = new Splide(slider, sliderOptions);
      const indicator = slider.querySelector('.js-current-slide');
      
      // Set initial indicator state
      if (indicator) {
        indicator.textContent = "1";
      }

      splide.on('move', function (newIndex) {
        // newIndex is zero-based (0, 1, 2...), so add 1 for human-readable display
        const currentSlideDisplay = newIndex + 1;
        
        // Access the total length directly from the splide instance
        const totalSlides = splide.length; 
        
        if (indicator) {
          indicator.textContent = currentSlideDisplay;
        }
      });

      splide.mount();
    });
  },
};

